import { useStore } from '../state/store';

export function Toasts() {
  const { toasts, dismissToast } = useStore((s) => ({
    toasts: s.toasts,
    dismissToast: s.dismissToast,
  }));
  return (
    <div className="toasts">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.kind}`} onClick={() => dismissToast(t.id)}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
